import { Locale } from 'shared/i18n/interface'
import { queryOptions, UseQueryOptions } from '@tanstack/react-query'
import { RatingsAndReviewsService, RatingsReviewsResponse } from 'shared/services/RatingsAndReviewsService'

export const QUERY_KEY = 'ratings_and_reviews'

export const queryRatings = (locale: Locale, mpvId: string, options?: Omit<UseQueryOptions<RatingsReviewsResponse>, 'queryKey'>) =>
  queryOptions({
    queryKey: [QUERY_KEY, { locale, mpvId }],
    queryFn: async () => RatingsAndReviewsService.getRatingsAndReviews(locale, mpvId),
    select: ({ reviewsCount, averageRating }) => ({ reviewsCount, averageRating }),
    ...options,
  })
